import React, { useEffect } from "react";
import PropTypes from "prop-types";
import {
  makeStyles,
  Container,
  Box,
  Grid,
  Tabs,
  Tab,
  Typography,
} from "@material-ui/core";
import "../../../components/pages/dashboard/style/style.css";
import AdminComponent from "./adminComponent";
import ActivityLogsComponent from "./activityLogsComponent";
import UserTracking from "./userTracking";
import Dealerfeed from "./dealerComponent";
import MyInventory from "./myinventoryComponent";
import DealerCommunicationTracking from "./dealerCommunicationTracking";
import ContactManagement from "./ContactManagement/contactManagement";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ContactManagementView from "./ContactManagement/contactManagementView";
import AddContactModal from "./ContactManagement/addContactModal";
import { useHistory } from "react-router";
import ShopifySettings from "./shopifySettings";
import BillingComponent from "./billingComponent";
import InvoiceSettings from "./inventorySettingsComponent";
import QboSettings from "../qboSettings";
import RssFeed from "./rssComponent";
import MfaSettings from "./mfaSetting";
import CustomLabel from "./customLabel";
import ApiHubComponent from "./apiHubComponent";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    // height: 650,
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  tab: {},
}));

const VerticalTabs = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [userDetails, setUserDetails] = React.useState(null);
  const [isApihubEnabled, setIsApihubEnabled] = React.useState(
    window.sessionStorage.getItem('isApiExposed') === 'true'
  );
  const accountId = window.sessionStorage.getItem("accountId");
  const useraccounts = window.sessionStorage.getItem("userDetails")
    ? JSON.parse(window.sessionStorage.getItem("userDetails"))
    : null;
  const isShopifyEnabled = window.sessionStorage.getItem('isShopifyEnabled') === 'true';
  // const isQboVerified = window.sessionStorage.getItem('isQboVerified') === 'true';
  const isQboEnabled = window.sessionStorage.getItem('isQboEnabled') === 'true';

  useEffect(() => {
    const auth = window.sessionStorage.getItem("userDetails")
      ? JSON.parse(window.sessionStorage.getItem("userDetails"))
      : null;
    setUserDetails(auth);

    const handleApiHubStatusChanged = (e) => {
      setIsApihubEnabled(e.detail.isApiExposed === true || e.detail.isApiExposed === 'true');
    };
    window.addEventListener('apiHubStatusChanged', handleApiHubStatusChanged);
    return () => window.removeEventListener('apiHubStatusChanged', handleApiHubStatusChanged);
  }, []);

  useEffect(() => {
    // history.replace('/administration');
    props.updateContactPage("contactHomePage");
    props.updateContactData(null);
  }, [history]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const businessConfig = () => {
    if (!useraccounts || !useraccounts.accountdetails) {
      return "";
    }
    const result = useraccounts.accountdetails.filter(
      (v) => v.accountid == accountId
    );
    return result.length ? result[0].businessname : "";
  };

  const tabItems = [
    { label: "User Management", component: <AdminComponent {...props} /> },
    { label: "Activity Logs", component: <ActivityLogsComponent {...props} /> },
    { label: "Dealers Feed", component: <Dealerfeed {...props} /> },
  ];

  if (isShopifyEnabled) {
    tabItems.push({
      label: "Shopify Settings",
      component: <ShopifySettings {...props} />
    });
    tabItems.push({
      label: "Billing",
      component: <BillingComponent {...props} />
    });
  }

  if (isQboEnabled) {
    tabItems.push({
      label: "Quickbook Settings",
      component: <QboSettings {...props} />
    });
  }

  tabItems.push({
    label: "My Inventory",
    component: <MyInventory {...props} />
  });

  if (userDetails && [2, 3, 6].includes(userDetails.roleId)) {
    tabItems.push({
      label: "Invoice Settings",
      component: <InvoiceSettings {...props} />
    });
  }

  if (userDetails && userDetails.roleId === 3) {
    tabItems.push({
      label: "Users Tracking",
      component: <UserTracking {...props} />
    });

    tabItems.push({
      label: "Dealer Tracking",
      component: <DealerCommunicationTracking {...props} />
    });
  }
    tabItems.push({
      label: "Chronogrid RSS",
      component: <RssFeed {...props} />
    });

  if (isApihubEnabled && userDetails && [2, 3, 6].includes(userDetails.roleId)) {
    tabItems.push({
      label: "API Hub",
      component: <ApiHubComponent {...props} />
    });
  }
    tabItems.push({
      label: "Security Settings",
      component: <MfaSettings {...props} />
    });
    if (userDetails && [2, 3, 6].includes(userDetails.roleId)) {
      tabItems.push({
        label: "Custom Labels",
        component: <CustomLabel {...props} />
      });
    }

  useEffect(() => {
    const params = new URLSearchParams(history.location.search || window.location.search);
    const tab = params.get("tab");
    if (tab === "billing") {
      const billingIndex = tabItems.findIndex((item) => item.label === "Billing");
      if (billingIndex >= 0) {
        setValue(billingIndex);
      }
    }
  }, [history.location.search, isShopifyEnabled, userDetails, isQboEnabled, isApihubEnabled]);

  // const { currentContactPage } = props;
  return (
    <div className={classes.root}>
      <Container maxWidth="xl">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} md={2}>
            {userDetails && userDetails.accountName && (
              <>
                <Typography
                  variant="h4"
                  className="color-CEA05F text-uppercase"
                  style={{ margin: "15px 0px" }}
                >
                  {businessConfig()}
                </Typography>
              </>
            )}
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={handleChange}
              className={classes.tabs}
            >
              {tabItems.map((item, index) => (
                <Tab
                  key={index}
                  label={`\u00A0\u00A0${item.label}`}
                  style={{ textTransform: "none",
                    ...(item.label === "Billing" ? { display: "none" } : {}), }}
                  {...a11yProps(index)}
                  className="color-383838"
                />
              ))}
            </Tabs>

          </Grid>
          <Grid item xs={12} sm={9} md={10}>
            {tabItems.map((item, index) => (
              <TabPanel key={index} value={value} index={index}
                style={item.label === "Billing" ? { display: "none" } : undefined}>
                {item.component}
              </TabPanel>
            ))}
          </Grid>

        </Grid>
      </Container>
    </div>
  );
};

const mapStateToProps = ({ ContactManagement }) => {
  return {
    currentContactPage: ContactManagement.contactManagement,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateContactPage: (type) => ({ type: type }),
      updateContactData: (payload) => ({ type: "CONTACT_VIEW_DATA", payload })
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(VerticalTabs);
